$(document).ready(function(){
      $('.testimonials').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        adaptiveHeight: true,
        prevArrow:'<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow:'<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });


  $('.cst_social_grid').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: false,
        adaptiveHeight: true,
        prevArrow:'<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow:'<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
      {
        breakpoint: 991,
        settings: {
        slidesToShow: 2,
        arrows: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
        slidesToShow: 1,
        arrows: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        }
      }
    ]
      });

  // $('.shop_grid').slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: true,
  //       speed: 300,
  //       infinite: true,
  //       autoplaySpeed: 5000,
  //       autoplay: false,
  //       adaptiveHeight: false,
  //       prevArrow:'<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
  //       nextArrow:'<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'
  // });



        $('.cust_product_loop').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: false,
        adaptiveHeight: false,
        prevArrow:'<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
        nextArrow:'<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
      {
        breakpoint: 991,
        settings: {
        slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
        slidesToShow: 1
        }
      }
    ]
      });
  


  $('.cust_collection_loop').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    adaptiveHeight: false,
    prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 391,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });


  
  $(".accounts__create-customer").click(function(){
       $("#modal-create-customer").addClass("modal_fixed");
});


$('.shop_hotspot:first').addClass('is-active').siblings().addClass('click');
$('.ShopTheLook__Dot:first').addClass('dot-active').siblings().removeClass('dot-active');
  $('.ShopTheLook__Dot').click(function(){
    var get = $(this).attr('data-product-index');
     $(this).addClass('dot-active').siblings().removeClass('dot-active');
    //alert(get);
   $('.shop_hotspot').each(function(){
    var set = $(this).attr('data-product-index');
     //alert(set);
     if(get == set){
       $(this).addClass('is-active').siblings().removeClass('is-active');
       //alert(set);
     } else {
       $(this).addClass('click');
     }
     });
     });


      if ($(window).width() < 767) {
      $('.ShopTheLook__Dot').click(function(){  
      var shop_dot = $(this).attr('data-product-index');
      //$(this).addClass('shop_dot_active').siblings().removeClass('shop_dot_active');
      //$('.header-section').removeClass('scrolling');
        
      $('.popup_block').each(function(){
      var shop_item = $(this).attr('data-product-index'); 
        
      if(shop_dot == shop_item){ 
      $(this).addClass('shop_dot_active').siblings().removeClass('shop_dot_active');
      $('body').addClass("popup_main");
        $('.image-inner').addClass("is-zoomed");
        const $elem = $(".template-index .page-wrap");
        $elem[0].style.setProperty('transform', 'none', 'important');
       // $(".template-index.page-wrap").css("transform", "none");
      } else {
       $(this).addClass('shop_dot_click');
     }
        
      });
      });

        $('.popup_close').click(function(){
          $('.popup_block').removeClass('shop_dot_active');
          $('body').removeClass("popup_main");
           $('.image-inner').removeClass("is-zoomed");
          const $elem = $(".template-index .page-wrap");
        $elem[0].style.setProperty('transform', 'translateY(0)', 'important');
       
        });
        
      }
  setTimeout(function () {
  $('span.xsell-quick-add-to-cart-buy-icon').click(function(){ 
  setTimeout(function () {
  $(".js-mini-cart-trigger").click(); 
  }, 2500);
  });
  }, 5000);


  $(window).scroll(function(){
  var scr = $(window).scrollTop();
  if(scr > 60){  
   $('.announcement__bar-section').addClass('sticky');
   var announcementHeight = $('.announcement__bar-section').outerHeight();
    //console.log(headerHeight);
   $('header.scrolling').css("padding-top", announcementHeight);
  }
  else{
    $('.announcement__bar-section').removeClass('sticky');
    $('.the-raw-stone').css("padding-top", "0px");
  }
    
  });

//   if ($(window).width() > 741) {
//   	$('.zoom').zoom();  
// }
  
$(document).on('click','#for_prod_ring_box',function(){
    var var_id = $(this).attr('data-id');$(this).val('Adding...'); 
    var var_title = $(this).attr('data-title');
    var proPrice = $(this).parents('.bundle_prod_ring_box').find('.cst_meta_data #product-price .price-item.price-item--regular').html().split('$')[1];
    proPrice = parseFloat(proPrice);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {  id: var_id, quantity: 1 },
      success: function(data){
      $('#for_prod_ring_box').val(var_title);
        $('#for_prod_ring_box').val('Added');
        var subtotlePrice = $('.footer-item-add-bundle .price__monet .money').html();
        subtotlePrice = subtotlePrice.split('$')[1];
        var totalprice = parseFloat(subtotlePrice) + proPrice;
        $('.footer-item-add-bundle .price__monet .money').html('$'+totalprice);
      // $(".js-mini-cart-trigger").click();
      //console.log("Add to cart success");
      },
      error: function(){
      $('#for_prod_ring_box').val(var_title);
      //console.log("Add to cart  Errors");
      }
    });

});

  var sizeActive = $('.variant_size input:checked').val();
  var slideStoneActive = $('.variant_sidestones input:checked').val();
  if(sizeActive != undefined){
    $('.sizeVariant .headingPart span').html(sizeActive);
    $('.sizeVariant .variantChange span').html(sizeActive);
    $('.sizeVariant ul[name="sizeVariantSelect"] li[value="'+sizeActive+'"]').addClass('active');
  }
  if(slideStoneActive != undefined){
    $('.Sidestones .headingPart span').html(slideStoneActive);
    $('.Sidestones .variantChange span').html(slideStoneActive);
    $('.Sidestones ul[name="sidestonesVariantSelect"] li[value="'+slideStoneActive+'"]').addClass('active');
  }

  $('.sizeVariant ul[name="sizeVariantSelect"] li').click(function(){
    var sizeValue = $(this).attr('value');
    $('.sizeVariant .headingPart span').html(sizeValue);
    $('.sizeVariant .variantChange span').html(sizeValue);
    $('.sizeVariant ul[name="sizeVariantSelect"] li').removeClass('active');
    $('.sizeVariant ul[name="sizeVariantSelect"] li[value="'+sizeValue+'"]').addClass('active');
    $('.swatches__swatch--regular input[value="'+sizeValue+'"]').click();
    $(this).parents('.sizeVariant .optionValues').removeClass('active');
  });

  $('.Sidestones ul[name="sidestonesVariantSelect"] li').click(function(){
    var sizeValue = $(this).attr('value');
    $('.Sidestones .headingPart span').html(sizeValue);
    $('.Sidestones .variantChange span').html(sizeValue);
    $('.Sidestones ul[name="sidestonesVariantSelect"] li').removeClass('active');
    $('.Sidestones ul[name="sidestonesVariantSelect"] li[value="'+sizeValue+'"]').addClass('active');
    $('.swatches__swatch--regular input[value="'+sizeValue+'"]').click();
    $(this).parents('.Sidestones .optionValues').removeClass('active');
  });
  
  $('.variantChange').click(function(){
    $(this).parents('.optionValues').toggleClass('active');
  });
  
$('.tabLink').click(function(){
  $('.tabLink').removeClass('active');
  var getData = $(this).attr('data-tab');
  $(this).addClass('active');
  $('.tabsData').addClass('hide');
  $('.tabsData[data-tab="'+getData+'"]').removeClass('hide');
});
  
});


